import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";

import {
  testSessionsSlice,
  TestSessionsState,
} from "./slices/testSessionsSlice";
import { initSlice, InitState } from "./slices/init";
import {
  sessionSetupSlice,
  SessionSetupState,
} from "./slices/sessionSetupSlice";
import {
  administrationSlice,
  AdministrationState,
} from "./slices/administrationSlice";
import { setupWizardSlice, SetupWizardState } from "./slices/setupWizardSlice";
import {
  ValimateTestRequestSlice,
  IValimateTestRequestState,
} from "./slices/valimateTestRequest";
import { valimateSlice, ValimateState } from "./slices/valimateSlice";
import {
  sessionSummarySlice,
  SessionSummary,
} from "./slices/sessionSummarySlice";
import {
  reqResSlice,
  ReqResState
} from "./slices/ReqResSlice"
import {
  customProfilesSlice,
  CustomProfilesState,
} from "./slices/customProfilesSlice";

export interface ApplicationState {
  init: InitState;
  testSessions: TestSessionsState;
  sessionSetup: SessionSetupState;
  administration: AdministrationState;
  setupWizard: SetupWizardState;
  valimateTestRequest: IValimateTestRequestState;
  valimate: ValimateState;
  sessionSummarySlice: SessionSummary;
  reqRes: ReqResState;
  customProfiles: CustomProfilesState;
}

const store = configureStore({
  reducer: {
    init: initSlice.reducer,
    testSessions: testSessionsSlice.reducer,
    sessionSetup: sessionSetupSlice.reducer,
    administration: administrationSlice.reducer,
    setupWizard: setupWizardSlice.reducer,
    valimateTestRequest: ValimateTestRequestSlice.reducer,
    valimate: valimateSlice.reducer,
    sessionSummarySlice: sessionSummarySlice.reducer,
    reqRes: reqResSlice.reducer,
    customProfiles: customProfilesSlice.reducer,
  },
  middleware: [thunkMiddleware, ...getDefaultMiddleware()],
});

export default store;
